import { generate_calendar } from "./calendars";

const EXCLUDE_READ_ONLY = [
  "Birthdays",
  "Holidays in India",
  "holidays",
  "United Kingdom holidays",
  "India holidays",
];

class ScheduleInfo {
  constructor() {
    this.id = null;
    this.calendarId = null;

    this.title = null;
    this.body = null;
    this.isAllday = false;
    this.start = null;
    this.end = null;
    this.category = "";
    this.dueDateClass = "";
    this.isPrivate = false;
    this.location = "";
    this.attendees = [];

    this.color = "#000000";
    this.backgroundColor = null;
    this.dragBackgroundColor = null;
    this.borderColor = null;
    this.customStyle = "";

    this.isFocused = false;
    this.isPending = false;
    this.isVisible = true;
    this.isReadOnly = false;
    this.goingDuration = 0;
    this.comingDuration = 0;
    this.recurrenceRule = "";
    this.state = "";

    this.raw = {
      memo: "",
      hasToOrCc: false,
      hasRecurrenceRule: false,
      location: null,
      class: "public", // or 'private'
      creator: {
        name: "",
        avatar: "",
        company: "",
        email: "",
        phone: "",
      },
    };
  }
}

const generateCalendarTime = (schedule, renderStart, renderEnd, isAllDay) => {
  let getStartDate = "";
  let getEndDate = "";
  if (isAllDay == "none") {
    getStartDate = new Date(
      renderStart.hasOwnProperty("date_time")
        ? renderStart.date_time
        : renderStart.date,
    );
    getEndDate = new Date(
      renderEnd.hasOwnProperty("date_time")
        ? renderEnd.date_time
        : renderEnd.date,
    );
    schedule.isAllday = renderStart.hasOwnProperty("date_time") ? false : true;
  } else {
    getStartDate = new Date(
      isAllDay ? renderStart.dateTime.split("T")[0] : renderStart.dateTime,
    );
    getEndDate = new Date(
      isAllDay ? renderEnd.dateTime.split("T")[0] : renderEnd.dateTime,
    );
    if (isAllDay == false) {
      getStartDate.setDate(getStartDate.getDate() + 1);
      getEndDate.setDate(getEndDate.getDate() + 1);
    }
    schedule.isAllday = isAllDay;
  }

  const startDate = moment(getStartDate.getTime());
  let endDate = moment(getEndDate.getTime());
  const diffDate = endDate.diff(startDate, "days");

  if (schedule.isAllday) {
    schedule.category = "allday";
    // startDate.add(diffDate, "days")
    schedule.start = startDate.toDate();
    schedule.end = schedule.start;
  } else {
    schedule.category = "milestone";
    // startDate.add(diffDate, "days")
    startDate.hours(getStartDate.getHours());
    startDate.minutes(getStartDate.getMinutes());
    schedule.start = startDate.toDate();
    schedule.end = startDate.toDate();
  }

  // schedule.goingDuration = chance.integer({ min: 30, max: 120 });
  // schedule.comingDuration = chance.integer({ min: 30, max: 120 });
};

const generateCalendarSchedule = (calendar, data, event) => {
  const schedule = new ScheduleInfo();
  schedule.id = event.id;
  schedule.calendarId = calendar.id;

  schedule.title =
    data.service_type == "Microsoft" ? event.subject : event.summary;
  schedule.body =
    data.service_type == "Microsoft" ? event.bodyPreview : event.description;
  schedule.isReadOnly = EXCLUDE_READ_ONLY.includes(calendar.name)
    ? true
    : false;

  data.service_type == "Microsoft"
    ? generateCalendarTime(schedule, event.start, event.end, event.isAllDay)
    : generateCalendarTime(schedule, event.start, event.end, "none");
  schedule.isPrivate =
    data.service_type == "Microsoft"
      ? event.sensitivity.includes("normal")
        ? false
        : true
      : event.hasOwnProperty("private_copy")
        ? event.private_copy
        : schedule.isPrivate;
  schedule.location = event.hasOwnProperty("location")
    ? data.service_type == "Microsoft"
      ? event.location.displayName
      : event.location
    : schedule.location;
  schedule.attendees = event.hasOwnProperty("attendees")
    ? event.attendees.map((dea) =>
        data.service_type == "Microsoft" ? dea.emailAddress.address : dea.email,
      )
    : schedule.attendees;
  // schedule.recurrenceRule = chance.bool({ likelihood: 20 }) ? "repeated events" : ""
  schedule.recurrenceRule =
    data.service_type == "Microsoft"
      ? event.recurrence
      : schedule.recurrenceRule;
  schedule.state =
    data.service_type == "Microsoft" ? event.showAs : schedule.state;
  schedule.color = schedule.color;
  schedule.backgroundColor = calendar.backgroundColor;
  schedule.dragBackgroundColor = calendar.dragBackgroundColor;
  schedule.borderColor = calendar.borderColor;

  // if (schedule.category === "milestone") {
  if (!schedule.isAllday) {
    schedule.color = schedule.backgroundColor;
    schedule.backgroundColor = "transparent";
    schedule.dragBackgroundColor = "transparent";
    schedule.borderColor = "transparent";
  }

  schedule.raw.creator.email =
    data.service_type == "Microsoft"
      ? event.organizer.address
      : event.creator.email;

  // if (chance.bool({ likelihood: 20 })) {
  //   const travelTime = chance.minute();
  //   schedule.goingDuration = travelTime;
  //   schedule.comingDuration = travelTime;
  // }

  return schedule;
};

export function generate_event_schedule(body) {
  const schedules = [];
  if (body && body.data) {
    let ggc = generate_calendar(body.data);
    console.log("calendarListInfo", ggc);
    body.data.selected_calendar.forEach((cl) => {
      if (cl.selected) {
        let event = body.data.event.find((evt) => evt[cl.calendarName]);
        let eventCalendarName = [];
        switch (body.data.service_type) {
          case "Google":
            eventCalendarName = event[cl.calendarName];
            break;
          case "Microsoft":
            eventCalendarName = event[cl.calendarName]["value"];
            break;
        }
        eventCalendarName.forEach((evt) => {
          let select_calendar = ggc.find((gg) => {
            return gg.name == cl.calendarName;
          });
          schedules.push(
            generateCalendarSchedule(select_calendar, body.data, evt),
          );
        });
      }
    });
  }
  console.log("schedules", schedules);
  return schedules;
}
